import BaseImage from './Image';

// EXPORT
export const Image = BaseImage;
export type { ImageProps } from './Image.interface';
